import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { detailCourseSelect, getCourseList } from 'redux-api/slices/courseSlice';
import { BITRIX, PATHS } from 'common/constants';
import { courseLink, withExtraCourses } from 'common/extraCourses';
import allCoursesIcon from 'assets/image/home/hmAllCourses.webp';
import logoMark from 'assets/icons/home/hmCoreLogo.svg';
import pattern from 'assets/icons/home/hmMenuPattern.svg';
import iconClock from 'assets/icons/home/hmIconClock.svg';
import iconSearch from 'assets/icons/home/hmIconSearch.svg';
import testArrow from 'assets/icons/home/hmTestArrow.svg';
import HomeButton from './HomeButton';
import classes from './HeaderCoursesMenu.module.scss';


// Выпадающее меню курсов из макета: список курсов с бэкенда и блок с тестом.
// mobile — вариант для бургер-меню: две колонки и компактный блок с тестом.
const HeaderCoursesMenu = ({ onNavigate, mobile = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { courseList } = useSelector(detailCourseSelect);
  const courses = withExtraCourses(courseList.courses ?? []);

  useEffect(() => {
    if (!courseList.courses?.length) dispatch(getCourseList());
    return () => null;
  }, [ dispatch, courseList.courses ]);

  return (
    <div className={`${classes.panel} ${mobile ? classes.panelMobile : ''}`}>
      <div className={classes.columns}>
        <Link className={`${classes.item} ${classes.itemAll}`} to={PATHS.allcourses} onClick={onNavigate}>
          <span className={classes.icon}>
            <img src={allCoursesIcon} alt="" />
          </span>
          <span className={classes.label}>{t('AllCourses')}</span>
        </Link>

        {courses.map((course, i) => (
          <Link
            className={classes.item}
            to={courseLink(course)}
            key={course.slug ?? i}
            onClick={onNavigate}
          >
            <span className={`${classes.icon} ${course.inactive_preview_image ? '' : classes.iconFallback}`}>
              <img
                src={course.inactive_preview_image || logoMark}
                alt={course.inactive_preview_image_alt || ''}
                loading="lazy"
              />
            </span>
            <span className={classes.label}>{course.title}</span>
          </Link>
        ))}
      </div>

      <div className={classes.promo}>
        <img className={classes.promoPattern} src={pattern} alt="" />

        <p className={classes.promoTitle}>{t('TakeTheQuizToFindYourWay')}</p>
        <HomeButton href={BITRIX.test} className={classes.promoBtn}>{t('Test')}</HomeButton>

        <span className={`${classes.badge} ${classes.badgeHint}`}>
          <img src={iconSearch} alt="" />
          Поможет выбрать
          <br />
          твоё направление
        </span>
        <span className={`${classes.badge} ${classes.badgeTime}`}>
          <img src={iconClock} alt="" />
          5-10 минут
        </span>

        <span className={classes.note}>Твой следующий шаг</span>
        <img className={classes.noteArrow} src={testArrow} alt="" />
      </div>
    </div>
  );
};

export default HeaderCoursesMenu;
